export default "__VITE_ASSET__C0PB6Egq__"